// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout-module--layout--3nj_J"};